import {createFeatureSelector, createSelector} from '@ngrx/store';
import {StoreKeys} from '../../models/store-keys';
import {RouterPathState} from './reducer/router-path.reducer';


export const selectRouterPathFeature = createFeatureSelector<RouterPathState>(StoreKeys.ROUTER_PATH);

export const selectRouterPathCloseRoute = createSelector(selectRouterPathFeature, state => state.datas.closeRoute);

export const selectRouterPathDatasHistory = createSelector(selectRouterPathFeature, state => state.datas.history);
